module.exports = __webpack_public_path__ + "img/google-play-store.1e91d02c.png";